var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12 col-lg-12" },
      [
        _c(
          "c-table",
          {
            ref: "materialTable",
            attrs: {
              title: "사용부서 목록",
              tableId: "materialTable",
              columns: _vm.grid.columns,
              data: _vm.grid.data,
              columnSetting: false,
              selection: "multiple",
              rowKey: "col1",
              filtering: false,
              usePaging: false,
              hideBottom: true,
            },
            on: { rowClick: _vm.rowClick },
          },
          [
            _c(
              "template",
              { slot: "table-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      attrs: { label: "추가", icon: "add" },
                      on: { btnClicked: _vm.addrow },
                    }),
                    _c("c-btn", { attrs: { label: "삭제", icon: "remove" } }),
                    _vm.editable
                      ? _c("c-btn", { attrs: { label: "저장", icon: "save" } })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }